import type { HTMLAttributes, ReactNode } from "react";

import styles from "./Chip.module.css";

type ChipTone = "success" | "danger" | "warning" | "neutral";

const toneClassNameMap: Record<ChipTone, string> = {
  success: styles.success,
  danger: styles.danger,
  warning: styles.warning,
  neutral: styles.neutral,
};

export interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  tone?: ChipTone;
}

/**
 * @deprecated Use `StatusBadge` from `components/shared` for new code.
 * `StatusBadge` covers the same 4 tones plus `info`, three variants
 * (solid / soft / outline), and a `color` escape hatch for custom hexes.
 * Existing `Chip` consumers keep working — migration happens incrementally
 * during cleanup waves where each consumer is visually verified.
 */
function Chip({ children, tone = "neutral", className = "", ...props }: ChipProps) {
  return (
    <span
      className={`${styles.chip} ${toneClassNameMap[tone]}${className ? ` ${className}` : ""}`}
      {...props}
    >
      {children}
    </span>
  );
}

export default Chip;
